import { ChartOfAccount } from "./chart-of-account";
import { PaymentMethod } from "./payment-method";
import { ShopCurrency } from "./shop-currency";
import { SystemField } from "./system-field";

export class CashAccount extends SystemField { 
     payment_method_id?:string;
     name?:string;
     currency_id?:string;
     chart_of_acc_id?:string;
     is_active?:number;
     is_receive_acc?:number;
     accept_currency_ids?:string;
     company_id?:string;
     pos_usable?:number;
     ordering?:number;
     icon?:string;
     image?:string;

     //formula fields
     accept_currencies?:ShopCurrency[];

     //Relationship
     payment_method?:PaymentMethod;
     currency?:ShopCurrency;
     chartofaccount?:ChartOfAccount;
}
